"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var TriggerClass_1 = __importDefault(require("./TriggerClass"));
var Scroll = /** @class */ (function (_super) {
    __extends(Scroll, _super);
    function Scroll(value) {
        var _this = _super.call(this) || this;
        _this.scrollPositionThreshold = value;
        _this.throttlePause = false;
        return _this;
    }
    Scroll.prototype.init = function (actionCallback) {
        var _this = this;
        (0, helpers_1.bindEvent)(window, 'scroll', function () {
            if (_this.isDeprecated || _this.hasRendered || _this.throttlePause)
                return;
            _this.throttlePause = true;
            setTimeout(function () {
                _this.throttlePause = false;
                var scrollPosition = (0, helpers_1.getScrollPosition)();
                if (scrollPosition >= _this.scrollPositionThreshold) {
                    _this.hasRendered = true;
                    actionCallback();
                }
            }, 150);
        });
    };
    Scroll.prototype.toString = function () {
        return "trigger scroll when user has scroller ".concat(this.scrollPositionThreshold, "% of the page");
    };
    return Scroll;
}(TriggerClass_1.default));
exports.default = Scroll;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2Nyb2xsLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvdHJpZ2dlcnMvU2Nyb2xsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEscUNBQXdEO0FBQ3hELGdFQUE0RDtBQUU1RDtJQUFvQywwQkFBWTtJQUk1QyxnQkFBWSxLQUFhO1FBQXpCLFlBQ0ksaUJBQU8sU0FHVjtRQUZHLEtBQUksQ0FBQyx1QkFBdUIsR0FBRyxLQUFLLENBQUE7UUFDcEMsS0FBSSxDQUFDLGFBQWEsR0FBRyxLQUFLLENBQUE7O0lBQzlCLENBQUM7SUFFRCxxQkFBSSxHQUFKLFVBQUssY0FBNkI7UUFBbEMsaUJBaUJDO1FBaEJHLElBQUEsbUJBQVMsRUFBQyxNQUFNLEVBQUUsUUFBUSxFQUFFO1lBQ3hCLElBQUksS0FBSSxDQUFDLFlBQVksSUFBSSxLQUFJLENBQUMsV0FBVyxJQUFJLEtBQUksQ0FBQyxhQUFhO2dCQUFFLE9BQU07WUFFdkUsS0FBSSxDQUFDLGFBQWEsR0FBRyxJQUFJLENBQUE7WUFFekIsVUFBVSxDQUFDO2dCQUNQLEtBQUksQ0FBQyxhQUFhLEdBQUcsS0FBSyxDQUFBO2dCQUUxQixJQUFNLGNBQWMsR0FBRyxJQUFBLDJCQUFpQixHQUFFLENBQUE7Z0JBRTFDLElBQUksY0FBYyxJQUFJLEtBQUksQ0FBQyx1QkFBdUIsRUFBRTtvQkFDaEQsS0FBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUE7b0JBQ3ZCLGNBQWMsRUFBRSxDQUFBO2lCQUNuQjtZQUNMLENBQUMsRUFBRSxHQUFHLENBQUMsQ0FBQTtRQUNYLENBQUMsQ0FBQyxDQUFBO0lBQ04sQ0FBQztJQUVELHlCQUFRLEdBQVI7UUFDSSxPQUFPLGdEQUF5QyxJQUFJLENBQUMsdUJBQXVCLGtCQUFlLENBQUE7SUFDL0YsQ0FBQztJQUNMLGFBQUM7QUFBRCxDQUFDLEFBaENELENBQW9DLHNCQUFZLEdBZ0MvQyJ9